<template>
  <div id="sign-in">
    <div class="logo">
      <!--suppress HtmlUnknownTarget -->
      <img
        height="30px"
        src="@/presentation/assets/img/logo.svg"
        alt="Sundata"
      />
    </div>

    <authentication @authenticated="onAuthenticated" />
  </div>
</template>

<script lang="ts">
import { useSessionStore } from '@/stores/SessionStore.ts';
import Authentication from './components/AuthenticationComponent.vue';
import { useCompanyStore } from '@/stores/CompanyStore.ts';

export default {
  name: 'SignIn',
  components: { Authentication },
  data() {
    return {
      isAuthenticated: useSessionStore().isAuthenticated(),
    };
  },
  emits: ['authenticated'],
  methods: {
    onAuthenticated(isAuthenticated, companiesOfMe) {
      this.isAuthenticated = isAuthenticated;
      if (companiesOfMe.length !== 0) {
        useCompanyStore().set(companiesOfMe[0]);
        this.goToNextPage();
      }
    },
    goToNextPage() {
      this.$emit('authenticated');

      const nextUrl = this.$route.query.nextUrl;
      const target = Array.isArray(nextUrl) ? nextUrl[0] : nextUrl;

      this.$router.push(target || 'Dashboard');
    },
  },
};
</script>

<style scoped></style>
